import { render, staticRenderFns } from "./SettlementPaymentTable.vue?vue&type=template&id=94fb6038&scoped=true"
import script from "./SettlementPaymentTable.vue?vue&type=script&lang=js"
export * from "./SettlementPaymentTable.vue?vue&type=script&lang=js"
import style0 from "./SettlementPaymentTable.vue?vue&type=style&index=0&id=94fb6038&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94fb6038",
  null
  
)

export default component.exports